const mEditionBillingPaymentMethodsModalActionDisabled = {
  mEditionBillingPaymentMethodsModalActionDisabled: {
    buttonPrimary: 'Entendido',
    message: 'Este medio de pago está relacionado con la venta de uno o más productos, para poder desactivarlo de manera global primero debes desactivar su relación de venta.',
    title: 'ACCIÓN DESHABILITADA'
  }
}
export default mEditionBillingPaymentMethodsModalActionDisabled
